<div class="products-container">

  <div class="w-100 flex-direction-row justify-content-between align-items-center">
    <h4 class="pc__title">Products</h4>
    <button class="filled-button tall-button gap-5px" (click)="onClickAddProduct();">
      <img src="assets/svg/plus-white.svg" alt="">
        Add Product
    </button>
  </div>

  <ng-container [ngTemplateOutlet]="productsTableTemplate"></ng-container>
</div>

<!-- TEMPLATES -->
<ng-template #productsTableTemplate>
  <div class="pc__table mt-50px">
    <div class="pc-table__title-container">
      <span class="pc-table__title">Products / {{productsCount ?? productsCount}}</span>
    </div>

    <div class="table-responsive">
      <table class="pc__table_el table mb-0 text-nowrap table-hover table-centered table-with-checkbox">
        <thead class="table-light">
        <tr>
          <th>#</th>
          <th>Product</th>
          <th>Price (AMD)</th>
          <th>Status</th>
          <th class="pc__table_action">Action</th>
        </tr>
        </thead>
        <tbody>
          @for (product of products; track $index) {
            <tr>
              <td class="fw-semibold">
                {{ (currentPage * productSize) + $index  + 1 }}
              </td>
              <td>
                <div class="flex-direction-row align-items-center gap-10px">
                  @if (product.isMainImageLoaded) {
                    <img class="table__product_pic" [src]="product.mainImageSafeUrl" alt="product picture">
                  } @else {
                    <div class="product_image_loading_container">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  }
                  <span>{{ product.productName }}</span>
                </div>
              </td>
              <td>{{ product.price }}</td>
              <td>
                <div class="flex-direction-row align-items-center gap-10px">
                  <div [ngClass]="product.availability == ProductAvailability.ACTIVE ? 'active-product' : 'inactive-product'"></div>
                  <span>{{ product.availability == ProductAvailability.ACTIVE ? 'Active' : 'Inactive' }}</span>
                </div>
              </td>
              <td>
              <mat-icon class="cursor-pointer p-0 m-0"
              [matMenuTriggerFor]="productActionsMenu"
              (click)="setSelectedProductId(product.id)"
              >
                more_vert
              </mat-icon>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <div class="pagination">
        <a (click)="goToPage(currentPage - 1)" [class.disabled]="currentPage === 0">&laquo;</a>
        <a *ngFor="let page of getPageNumbers()"
           (click)="goToPage(page - 1)"
           [class.active]="currentPage === (page - 1)">
          {{ page }}
        </a>
        <a (click)="goToPage(currentPage + 1)" [class.disabled]="currentPage === totalPages - 1">&raquo;</a>
      </div>
    </div>
  </div>
</ng-template>

<mat-menu #productActionsMenu="matMenu">
  <button mat-menu-item class="w-100 d-flex justify-content-between" (click)="redirectToEditPage()">
    <span>Edit</span>
    <img src="assets/svg/edit.svg">
  </button>
  @if (selectedProductId !== AUTO_SUBSCRIPTION_PRODUCT_ID) {
  <button mat-menu-item class="w-100 d-flex justify-content-between" (click)="deleteProduct()">
            <span>Delete</span>
    <img src="assets/svg/delete.svg">
  </button>
  }
</mat-menu>
